module.exports = __webpack_public_path__ + "img/ig.d12a24a7.png";